var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#CC0511",
  fillRule: "evenodd",
  d: "M1.367 10h9.266L6 1.998zm0 1a1 1 0 0 1-.865-1.501l4.632-8.002a1 1 0 0 1 1.731 0l4.633 8.002A1 1 0 0 1 10.633 11z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#CC0511",
  d: "M6.5 7.5h-1V4.25h1zM5.375 8.625a.625.625 0 1 1 1.25 0 .625.625 0 0 1-1.25 0"
})));
export { SvgWarning as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0ibm9uZSI+CiAgPHBhdGggZmlsbD0iI0NDMDUxMSIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMS4zNjcgMTBoOS4yNjZMNiAxLjk5OCAxLjM2NyAxMFptMCAxYTEgMSAwIDAgMS0uODY1LTEuNTAxbDQuNjMyLTguMDAyYTEgMSAwIDAgMSAxLjczMSAwbDQuNjMzIDguMDAyQTEgMSAwIDAgMSAxMC42MzMgMTFIMS4zNjdaIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz4KICA8cGF0aCBmaWxsPSIjQ0MwNTExIiBkPSJNNi41IDcuNWgtMVY0LjI1aDFWNy41Wk01LjM3NSA4LjYyNWEuNjI1LjYyNSAwIDEgMSAxLjI1IDAgLjYyNS42MjUgMCAwIDEtMS4yNSAwWiIvPgo8L3N2Zz4K";